import { useEffect, useRef } from 'react';

import { ReactComponent as Logo } from '../../assets/logo-light.svg';
import background from '../../assets/woman-background-first-frame.png';
import video from '../../assets/woman-background.mp4';
import { Icon } from '../../common/Icon/Icon';
import { useUserContext } from '../../core/context/user.context';
import LoginForm from './LoginForm/LoginForm';
import './VideoBanner.css';

function VideoBanner() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const { user } = useUserContext();

  useEffect(() => {
    if (!videoRef.current) return;
    videoRef.current.playbackRate = 0.5;
  }, []);

  return (
    <section className="video-banner">
      {prefersReducedMotion ? (
        <img className="video-banner__background cover-img" src={background} alt="" />
      ) : (
        <>
          <img className="video-banner__background cover-img" src={background} alt="" />
          <video
            className="video-banner__video cover-img"
            autoPlay
            muted
            playsInline
            ref={videoRef}
          >
            <source src={video} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </>
      )}
      <div className="wrap wrap--lg">
        <div className="video-banner__container">
          <Logo className="video-banner__logo" />
          <h1 className="video-banner__title h3">Welcome</h1>
          {user.email ? (
            <a className="video-banner__cta" href={`/pg${window.location.search}`}>
              Lets go{' '}
              <span>
                <Icon.Arrow />
              </span>
            </a>
          ) : (
            <LoginForm />
          )}
        </div>
      </div>
    </section>
  );
}

export default VideoBanner;
